module.exports = __webpack_public_path__ + "img/404.91963a44.svg";